import React from 'react';

import { User } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const EmailMessage = props => (
  <>
    <div className="bdrs-base bg-white p-16 mb-24 bs-2">
      <div className="d-f ai-c mb-16">
        <User className="mr-8" />
        <span className="d-f fd-c w-fill pr-24">
          <Text variant={TEXT_VARIANTS.BODY_BOLD}>{props.data.from}</Text>
          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            {props.timeStamp}
          </Text>
        </span>
      </div>
      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>{props.data.subject}</Text>
      <hr className="mt-12 mb-12" />
      <Text className="ws-pl" variant={TEXT_VARIANTS.SUBHEADER}>
        {props.data.body}
      </Text>
    </div>
    <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD} className="mt-16">
      {t('questions.question.email_reply.reply_placeholder')}
    </Text>
  </>
);

export default EmailMessage;
